import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from './components/HelloWorld copy.vue';
import DataFaq from './components/view/viewFaq/Vfaq.vue';
import DataArea from './components/view/viewArea/Varea.vue';
import DataService from './components/view/viewService/Vservice.vue';
import DataVehicle from './components/view/viewVehicle/Vvehicle.vue';
import DataFeedback from './components/view/viewRate/Vrate.vue';
import DataApplicant from './components/view/viewApplicant/Vapplicant.vue';
import DataCareer from './components/view/viewCareer/Vcareer.vue';
import DataRequirement from './components/view/viewRequirement/Vrequirement.vue';
import DataOperasional from './components/view/viewOperasional/Voperasional.vue';
import DataMilestone from './components/view/viewMilestone/Vmilestone.vue';
import DataClient from './components/view/viewClient/Vclient.vue';
import DataAdvantage from './components/view/viewAdvantage/Vadvantage.vue';
import DataTechnology from './components/view/viewTechnology/Vtechnology.vue';
import DataSdgs from './components/view/viewSdgs/Vsdgs.vue';
import DataNews from './components/view/viewNews/Vnews.vue';
import DataQuestion from './components/view/viewQuestion/Vquestion.vue';
import DataAnswer from './components/view/viewAnswer/Vanswer.vue';
import DataComplaint from './components/view/viewComplaint/Vcomplaint.vue';
import DataGudang from './components/view/viewGudang/Vgudang.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: HelloWorld,
            meta: { requiresAuth: true }
        },
        {
            path: '/data-gudang',
            name: 'data-gudang',
            component: DataGudang
        },
        {
            path: '/data-faq',
            name: 'data-faq',
            component: DataFaq
        },
        {
            path: '/data-area',
            name: 'data-area',
            component: DataArea
        },
        {
            path: '/data-service',
            name: 'data-service',
            component: DataService
        },
        {
            path : '/data-rate',
            name : 'data-rate',
            component: DataFeedback
        },
        {
            path : '/data-vehicles',
            name : 'data-vehicles',
            component: DataVehicle
        },
        {
            path : '/data-applicants',
            name : 'data-applicants',
            component: DataApplicant
        },
        {
            path : '/data-career',
            name : 'data-careers',
            component: DataCareer
        },
        {
            path : '/data-requirements',
            name : 'data-requirements',
            component: DataRequirement
        },
        {
            path : '/data-operasional',
            name : 'data-operasional',
            component: DataOperasional
        },
        {
            path : '/data-milestones',
            name : 'data-milestones',
            component: DataMilestone
        },
        {
            path : '/data-client',
            name : 'data-client',
            component : DataClient
        },
        {
            path : '/data-advantage',
            name : 'data-advantage',
            component : DataAdvantage
        },
        {
            path : '/data-technology',
            name : 'data-technology',
            component : DataTechnology
        },
        {
            path : '/data-sdgs',
            name : 'data-sdgs',
            component : DataSdgs
        },
        {
            path : '/data-berita',
            name : 'data-berita',
            component : DataNews
        },
        {
            path : '/data-question',
            name : 'data-question',
            component : DataQuestion
        },
        {
            path : '/data-answer',
            name : 'data-answer',
            component : DataAnswer
        },
        {
            path : '/data-complaint',
            name : 'data-complaint',
            component : DataComplaint
        }
    ],
});

export default router;